import Box from '@mui/material/Box'
import { useNavigate } from 'react-router-dom'

import { instrumentDashboardPath } from '@/features/campaigns/lib/instrumentDashboardNavigation'
import type { CampaignInstrument } from '@/features/campaigns/types'
import {
  campaignHomePath,
  instrumentBuilderPath,
} from '@/features/instruments/lib/instrumentNavigation'

import { DashboardIconAction, dashboardActionsRowSx } from './DashboardIconAction'

interface Props {
  instrument: CampaignInstrument
  campaignId: string
  canEdit: boolean
}

export function AllocatedInstrumentRowActions({
  instrument,
  campaignId,
  canEdit,
}: Readonly<Props>) {
  const navigate = useNavigate()
  const { id, status } = instrument

  if (status === 'draft') {
    if (!canEdit) return null
    return (
      <Box sx={dashboardActionsRowSx}>
        <DashboardIconAction
          variant="continue"
          label="Continue Building"
          testId={`ev-dashboard-instrument-continue-${id}`}
          onClick={() => navigate(instrumentBuilderPath(id))}
        />
      </Box>
    )
  }

  const showResponseDashboard =
    status === 'active' ||
    status === 'paused' ||
    status === 'completed' ||
    status === 'expired' ||
    (status === 'closed' &&
      (instrument.closeReason === 'target_reached' ||
        instrument.closeReason === 'timeline_expired'))

  return (
    <Box sx={dashboardActionsRowSx}>
      <DashboardIconAction
        variant="launch"
        label="View Launching Screen"
        testId={`ev-dashboard-instrument-launch-${id}`}
        onClick={() => navigate(campaignHomePath(campaignId))}
      />
      {showResponseDashboard ? (
        <DashboardIconAction
          variant="analytics"
          label="View Response Dashboard"
          testId={`ev-dashboard-instrument-response-dashboard-${id}`}
          onClick={() => navigate(instrumentDashboardPath(id))}
        />
      ) : null}
    </Box>
  )
}
